import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Arrays from '../../../../java/util/Arrays';
import System from '../../../../java/lang/System';
var IntArrayList = /*#__PURE__*/function () {
  function IntArrayList() {
    _classCallCheck(this, IntArrayList);
    IntArrayList.constructor_.apply(this, arguments);
  }
  _createClass(IntArrayList, [{
    key: "size",
    value: function size() {
      return this._size;
    }
  }, {
    key: "addAll",
    value: function addAll(values) {
      if (values === null) return null;
      if (values.length === 0) return null;
      this.ensureCapacity(this._size + values.length);
      System.arraycopy(values, 0, this._data, this._size, values.length);
      this._size += values.length;
    }
  }, {
    key: "ensureCapacity",
    value: function ensureCapacity(capacity) {
      if (capacity <= this._data.length) return null;
      var newLength = Math.max(capacity, this._data.length * 2);
      this._data = Arrays.copyOf(this._data, newLength);
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = new Array(this._size).fill(null);
      System.arraycopy(this._data, 0, array, 0, this._size);
      return array;
    }
  }, {
    key: "add",
    value: function add(value) {
      this.ensureCapacity(this._size + 1);
      this._data[this._size] = value;
      ++this._size;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._data = null;
      this._size = 0;
      if (arguments.length === 0) {
        IntArrayList.constructor_.call(this, 10);
      } else if (arguments.length === 1) {
        var initialCapacity = arguments[0];
        this._data = new Array(initialCapacity).fill(null);
      }
    }
  }]);
  return IntArrayList;
}();
export { IntArrayList as default };